import { Box, Card, CardContent, CardHeader } from '@mui/material';

const SettingItem = ({ title, subheader, Icon, children }) => {
    return (
        <Card>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <CardHeader
                    title={title}
                    subheader={subheader}
                    avatar={<Icon color="primary" />}
                />
                <CardContent>{children}</CardContent>
            </Box>
        </Card>
    );
};

export default SettingItem;
